import { createApp } from 'vue'
import installElementPlus from '@/plugins/element'
import installElementIcon from '@/plugins/elementIcon'
import installI18n from '@/plugins/i18n'
import store from './store'
import router from './router'
import App from './App.vue'
import { VueClipboard } from '@soerenmartius/vue3-clipboard'

let app = createApp(App)

installElementPlus(app)
installElementIcon(app)
installI18n(app)

app.use(store).use(router).use(VueClipboard).mount('#app')
